import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks.min';

function init() {
    document.addEventListener('lazybeforeunveil', (e) => {
        const bg = e.target.getAttribute('data-bg');

        if (bg) {
            e.target.style.backgroundImage = `url(${bg})`;
        }
    });
}

export default init;
